import React , { useCallback,useEffect,useState } from 'react';
import { Table,Spin,Input,Modal,Button,message,Select,InputNumber,Popover} from 'antd';
import PlayerCard from './PlayerCard';
import _ from "lodash";
// import { useReactToPrint } from 'react-to-print';
function ProjectionsPosition (props) {
    const { Option } = Select;
    const [teams, setTeams] = useState([]);
    const [teamData, setTeamData] = useState([]);
    const [projections, setProjections] = useState([]);
    const [sorter, setSorter] = useState("PPG");
    const [PFFdata, setPFFdata] = useState([]);
    const [PFFteamData, setPFFteamData] = useState([]);
    const calculateProjections = async (projection)=>{
      const {  PassingPlays =0,RushingPlays=0} = teamData?.find(f => f.NFL_TeamID ===projection.NFL_TeamID)||{}
     projection.PassingAttempts=Math.round(PassingPlays*projection.PassAttemptRate/100*100)/100
     projection.CompletionPercentage=Math.round(projection.XCompletionPercentage*projection.CompletionPercentageFactor/100*100)/100
     projection.YardsPerCompletion=Math.round(projection.XYardsPerCompletion*projection.YardsPerCompletionFactor/100*100)/100
     projection.YardsPerAttempt=Math.round(projection.CompletionPercentage*projection.YardsPerCompletion/100*100)/100
     projection.Yards=Math.round(projection.YardsPerAttempt*projection.PassingAttempts*100)/100
     projection.PassingTouchdownRate=Math.round(projection.XPassingTouchdownRate*projection.PassingTouchdownRateFactor/100*100)/100
     projection.PassingTouchdowns=Math.round(projection.PassingTouchdownRate*projection.PassingAttempts/100*100)/100
     projection.Routes=Math.round(projection.RouteParticipation*PassingPlays/100*100)/100
     projection.Targets=Math.round(projection.Routes*projection.TargetsPerRouteRun/100*100)/100;
     projection.TargetShare=Math.round(projection.Targets/projections.filter((p)=>p.Position==='QB').map(p=>p.PassingAttempts).reduce((pv, cv) => pv + cv, 0)*10000)/100
     projection.CatchRate=Math.round(projection.XCatchRate*projection.CatchRateFactor/100*100)/100
     projection.Receptions=Math.round(projection.CatchRate*projection.Targets/100*100)/100
     projection.YardsPerCatch=Math.round(projection.XYardsPerCatch*projection.YardsPerCatchFactor/100*100)/100
     projection.YardsPerTarget=Math.round(projection.CatchRate*projection.YardsPerCatch/100*100)/100
     projection.ReceivingYards=Math.round(projection.YardsPerTarget*projection.Targets*100)/100
     projection.ReceivingTouchdownRate=Math.round(projection.XReceivingTouchdownRate*projection.ReceivingTouchdownRateFactor/100*100)/100
     projection.ReceivingTouchdowns=Math.round(projection.ReceivingTouchdownRate*projection.Targets/100*100)/100
     projection.Carries=Math.round(projection.CarryShare*RushingPlays/100*100)/100
     projection.YardsPerCarry=Math.round(projection.XYardsPerCarry*projection.YardsPerCarryFactor/100*100)/100
     projection.RushingTouchdownRate=Math.round(projection.XRushingTouchdownRate*projection.RushingTouchdownRateFactor/100*100)/100
     projection.RushingYards=Math.round(projection.Carries*projection.YardsPerCarry*100)/100
     projection.RushingTDs=Math.round(projection.RushingTouchdownRate*projection.Carries/100*100)/100
        return projection
      }
    const getTeams = async ()=>{
        console.log("Fetching teams")
        fetch(`/api/db/getNFLTeams`,{
            headers : { 
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {console.log(data.response);setTeams(data.response);
        });
      }
    const getProjections = async ()=>{
        console.log("Fetching Projections")
        fetch(`/api/db/getProjections/1/2022/`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {setProjections(data.response.sort((a,b)=>calcPoints(b)-calcPoints(a)));
        });
      }
      const getTeamData = async ()=>{
        console.log("Fetching Projections")
        fetch(`/api/db/getTeamPlays/1/2022/`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {setTeamData(data.response);
        });
      }
      const getPFFData = async ()=>{
        console.log("Fetching Projections")
        fetch(`/api/db/getPFF/1/2022`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {setPFFdata(data.response);
        });
      }
      const getPFFTeamData = async ()=>{
        console.log("Fetching Projections")
        fetch(`/api/db/getTeamPFF/1/2022/`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {setPFFteamData(data.response);
        });
      }
    useEffect(()=> {
        getTeams();
    } ,[]);

    useEffect(()=> {
        getProjections();
        getTeamData();
        getPFFData();
        getPFFTeamData();
    },[] );

    useEffect(()=> {
      sortProjections();
      
  } ,[sorter]);
    
    const saveProjection = async (projection)=>{
      
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(projection)
    };
    return await fetch("/api/db/saveProjection/1",requestOptions)
  }
    const saveTeamProjection = async (projection)=>{
      
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(projection)
      };
    console.log("getting Saved", requestOptions)
      return await fetch("/api/db/saveTeamProjection/1",requestOptions)
    }

    const teamPopoverContent=(stat,Percent)=>(
      <div className='flexcol'>
          {PFFteamData.filter(d=>!d.Position).map(d=><div className='flexrow'><div style={{width:'80px'}}>{d.week||`${d.Year}(${d.Games})`}</div><div>{d[stat]}{Percent?'%':''}</div></div>)}
      </div>
  )

    const onProjectionChange= async (e,playerID,setting) => {
        console.log('stuff',playerID,setting,e.target.value)
        const tempProjections=projections;
        const ind=tempProjections.findIndex((r)=>r.NFL_PlayerID===playerID)
        console.log('position',ind)
        tempProjections[ind][setting]=e.target.value.replace('%', '')
        tempProjections[ind]= await calculateProjections(tempProjections[ind]).then(saveProjection(tempProjections[ind]))
        console.log("temp",tempProjections)
        
        setProjections([...tempProjections])
    };

  //   const onTeamDataChange= async (e,setting,team) => {
  //     console.log('stuff',setting,e.target.value)
  //     const tempData=teamData.find((td)=>td.NFL_TeamID=team);

  //     tempData[setting]=e.target.value.replace('%', '')
  //     const tempProjections=projections;
  //     saveTeamProjection(tempData);
  //     setTeamData([tempData]);
  //     for (var p of tempProjections.filter(tp=>tp.Position==='QB')) {
  //       p= await calculateProjections(p).then(saveProjection(p)).then(setProjections([...tempProjections]))
  //     }
  //     for (var p of tempProjections.filter(tp=>tp.Position!=='QB')) {
  //       p= await calculateProjections(p).then(saveProjection(p)).then(setProjections([...tempProjections]))
  //     }
  //     console.log("temp",tempProjections)
  // };
  const calcPoints=(data)=>{
    const receptionPts= data.Position==='WR'?1.25:(data.Position==='TE'?1.75:1)
    const PointsPer10= (data.Position==='TE'?1.5:1)
    return (Math.round((data.Yards/25+data.PassingTouchdowns*6+data.Receptions*receptionPts+data.ReceivingYards*PointsPer10/10+(data.RushingTDs+data.ReceivingTouchdowns)*6+data.RushingYards/10)*100)/100)
}
    const sortProjections = () =>{
      setProjections(prev=>[...prev.sort((a,b)=>{
        if (sorter==='PPG')
        {
            return calcPoints(b)-calcPoints(a)
        }
        else{
          return b[sorter]-a[sorter]
        }

        })])
    }
    
    const onSorterChange= e => {

        setSorter(e);

        //setSearchWord(e.target.value)
    };
    const spinner=
    <React.Fragment>
    <Spin />
    </React.Fragment>
    
    console.log('projections',projections)
    console.log('teamData',teamData)
    console.log('PFFData',PFFdata)
    console.log('PFFDataTeam',PFFteamData)
    return (
        <div>
            <Select
        size='small'
          mode="single"
          allowClear={false}
          style={{ width: '100%' }}
          value={sorter}
          onChange={(e)=>onSorterChange(e)}
          optionLabelProp="label"
        >
          {["KTCvalue","PPG"].map(b=>
          <Option value={b} label={b}>
              <div>{b}</div>
          </Option>)}
        </Select>
        
        <div className='flexrow'>
        <div className='flexcol'>
          <div className='positionBank'>
            <div className='positionBankTitle'>QB</div>
            {projections.filter((p)=>p.Position==='QB').slice(0,100).map((p)=><PlayerCard data={p} onChange={onProjectionChange} PFFdata={PFFdata.filter(d=>d.NFL_PlayerID===p.NFL_PlayerID).sort((a,b)=> (a.Year - b.Year || a.week - b.week ))}></PlayerCard>)}
          </div>
          <div className='positionBank'>
            <div className='positionBankTitle'>WR</div>
            {projections.filter((p)=>p.Position==='WR').slice(0,100).map((p)=><PlayerCard data={p} onChange={onProjectionChange} PFFdata={PFFdata.filter(d=>d.NFL_PlayerID===p.NFL_PlayerID).sort((a,b)=> (a.Year - b.Year || a.week - b.week ))}></PlayerCard>)}
          </div>
        </div>
        <div className='flexcol'>
          <div className='positionBank'> 
            <div className='positionBankTitle'>RB</div>
            {projections.filter((p)=>p.Position==='RB').slice(0,100).map((p)=><PlayerCard data={p} onChange={onProjectionChange} PFFdata={PFFdata.filter(d=>d.NFL_PlayerID===p.NFL_PlayerID).sort((a,b)=> (a.Year - b.Year || a.week - b.week ))}></PlayerCard>)}
          </div>
          <div className='positionBank'>
            <div className='positionBankTitle'>TE</div>
            {projections.filter((p)=>p.Position==='TE').slice(0,100).map((p)=><PlayerCard data={p} onChange={onProjectionChange} PFFdata={PFFdata.filter(d=>d.NFL_PlayerID===p.NFL_PlayerID).sort((a,b)=> (a.Year - b.Year || a.week - b.week ))}></PlayerCard>)}
          </div>
        </div>
        
            </div>
        </div>
        )
        
    }

    export default ProjectionsPosition;


